import type { TranslateDictionary } from './en.js';

export const Pl: TranslateDictionary = {
  'Start airplay': 'Rozpocznij AirPlay',
  'Stop airplay': 'Zatrzymaj AirPlay',
  Audio: 'Audio',
  Captions: 'Napisy',
  'Enable captions': 'Włącz napisy',
  'Disable captions': 'Wyłącz napisy',
  'Start casting': 'Rozpocznij przesyłanie',
  'Stop casting': 'Zatrzymaj przesyłanie',
  'Enter fullscreen mode': 'Włącz pełny ekran',
  'Exit fullscreen mode': 'Wyłącz pełny ekran',
  Mute: 'Wycisz',
  Unmute: 'Wyłącz wyciszenie',
  'Enter picture in picture mode': 'Włącz tryb obraz w obrazie',
  'Exit picture in picture mode': 'Wyłącz tryb obraz w obrazie',
  Play: 'Odtwórz',
  Pause: 'Wstrzymaj',
  'Playback rate': 'Szybkość odtwarzania',
  'Playback rate {playbackRate}': 'Szybkość odtwarzania {playbackRate}',
  Quality: 'Jakość',
  'Seek backward': 'Do tyłu',
  'Seek forward': 'Do przodu',
  Settings: 'Ustawienia',
  Auto: 'Auto',
  'audio player': 'odtwarzacz audio',
  'video player': 'odtwarzacz wideo',
  volume: 'Głośność',
  seek: 'Szukaj',
  'closed captions': 'Napisy',
  'current playback rate': 'aktualna szybkość odtwarzania',
  'playback time': 'czas odtwarzania',
  'media loading': 'ładowanie multimediów',
  settings: 'Ustawienia',
  'audio tracks': 'ścieżki audio',
  quality: 'Jakość',
  play: 'odtwórz',
  pause: 'wstrzymaj',
  mute: 'wycisz',
  unmute: 'wyłącz wyciszenie',
  'chapter: {chapterName}': 'rozdział: {chapterName}',
  live: 'na żywo',
  Off: 'Wyłączone',
  'start airplay': 'rozpocznij AirPlay',
  'stop airplay': 'zatrzymaj AirPlay',
  'start casting': 'rozpocznij przesyłanie',
  'stop casting': 'zatrzymaj przesyłanie',
  'enter fullscreen mode': 'włącz pełny ekran',
  'exit fullscreen mode': 'wyłącz pełny ekran',
  'enter picture in picture mode': 'włącz tryb obraz w obrazie',
  'exit picture in picture mode': 'wyłącz tryb obraz w obrazie',
  'seek to live': 'przejdź do transmisji na żywo',
  'playing live': 'odtwarzanie na żywo',
  'seek back {seekOffset} seconds': 'do tyłu {seekOffset} sek.',
  'seek forward {seekOffset} seconds': 'do przodu {seekOffset} sek.',
  'Network Error': 'Błąd sieci',
  'Decode Error': 'Błąd dekodowania',
  'Source Not Supported': 'Źródło nie jest obsługiwane',
  'Encryption Error': 'Błąd szyfrowania',
  'A network error caused the media download to fail.':
    'Błąd sieci spowodował niepowodzenie pobierania multimediów.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Błąd multimediów spowodował przerwanie odtwarzania. Multimedia mogą być uszkodzone lub Twoja przeglądarka nie obsługuje tego formatu.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Wystąpił nieobsługiwany błąd. Serwer lub sieć zawiodły, lub Twoja przeglądarka nie obsługuje tego formatu.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Multimedia są zaszyfrowane i nie ma kluczy do ich odszyfrowania.',
};
